// extracted by mini-css-extract-plugin
export const NavBar = "layout-module--NavBar--9QhCT";
export const PrimaryIcons = "layout-module--PrimaryIcons--2x3eZ";
export const Main = "layout-module--Main--2Jcft";
export const logo = "layout-module--logo---MXHy";
export const socialLinks = "layout-module--socialLinks--A_E1W";
export const socialIcons = "layout-module--socialIcons--2XEEE";
export const navbar = "layout-module--navbar--2JXTD";
export const navbarContent = "layout-module--navbarContent--20RT3";
export const submitLink = "layout-module--submitLink--3U_AW";